module.exports = __webpack_public_path__ + "static/TlwgTypewriter-BoldOblique-a0df310058d0f0bab4e7a4ae3c307d02.woff";